if (!customElements.get('rocket-carousel')) {
  class RocketCarousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.selectors = {
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };
      this.hideOnDesktop = this.hasAttribute('hide-on-desktop');
      this.initSlider();
    }
    initSlider() {
      if (this.hideOnDesktop && window.innerWidth > 1024) {
        return
      }
      const rocksetSwiperElement = this.querySelector(".swiper");
      if (!rocksetSwiperElement) return;

      this.sliderInstance = new window.FoxTheme.Carousel(rocksetSwiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: this.querySelector(this.selectors.nextEl),
          prevEl: this.querySelector(this.selectors.prevEl),
        },
        breakpoints: {
          768: {
            spaceBetween: 16
          }
        }
      });

      this.sliderInstance.init();
    }
  }

  customElements.define('rocket-carousel', RocketCarousel);
}
